import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/afterSale",
    name: "afterSale",
    component: dashboard,
    redirect: {
      name: "newProduct"
    },
    children: [
      {
        path: "newProduct",
        name: "newProduct",
        meta: { title: "新产品码验证统计" },
        component: () => import("@/views/afterSale/index.vue"),
        children: [
          {
            path: "add",
            name: "addNewProduct",
            meta: { title: "添加品牌" },
            component: () => import("@/views/afterSale/addInfo.vue")
          }
        ]
      },
      {
        path: "opinion",
        name: "opinion",
        meta: { title: "售后反馈意见管理" },
        component: () => import("@/views/opinion/index.vue"),
        children: []
      }
    ]
  }
];
